(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('EditIntegrationController', EditIntegrationController);

    EditIntegrationController.$inject = ['entity', '$state', 'Integration'];

    function EditIntegrationController (entity, $state, Integration) {
        var vm = this;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.client = entity;
            });
        }

        vm.clear = function() {
            $state.go('active-integration');
        }

        vm.save = function () {
            vm.isSaving = true;
            if (vm.client.clientId !== null) {
                Integration.update(vm.client, onSaveSuccess, onSaveError);
            } else {
                Integration.save(vm.client, onSaveSuccess, onSaveError);
            }
        };

        var onSaveSuccess = function () {
            vm.isSaving = false;
            $state.go('active-integration');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
    }
})();
